import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag, X } from 'lucide-react';
const recentBuyers = [{
  name: 'María L.',
  location: 'Buenos Aires',
  time: 'hace 2 minutos'
}, {
  name: 'Carolina S.',
  location: 'Córdoba',
  time: 'hace 5 minutos'
}, {
  name: 'Ana G.',
  location: 'Rosario',
  time: 'hace 8 minutos'
}, {
  name: 'Lucía M.',
  location: 'Mendoza',
  time: 'hace 12 minutos'
}, {
  name: 'Patricia R.',
  location: 'La Plata',
  time: 'hace 15 minutos'
}, {
  name: 'Gabriela F.',
  location: 'Mar del Plata',
  time: 'hace 18 minutos'
}, {
  name: 'Silvia D.',
  location: 'Tucumán',
  time: 'hace 22 minutos'
}, {
  name: 'Claudia V.',
  location: 'Salta',
  time: 'hace 25 minutos'
}, {
  name: 'Mónica P.',
  location: 'Santa Fe',
  time: 'hace 30 minutos'
}, {
  name: 'Andrea B.',
  location: 'Neuquén',
  time: 'hace 35 minutos'
}];
export function SaleNotification() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState(0);
  const [isDismissed, setIsDismissed] = useState(false);
  useEffect(() => {
    if (isDismissed) return;
    // Show first notification after 5 seconds
    const initialTimeout = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    return () => clearTimeout(initialTimeout);
  }, [isDismissed]);
  useEffect(() => {
    if (isDismissed) return;
    const interval = setInterval(() => {
      // Hide current notification
      setIsVisible(false);
      // After animation, show next notification
      setTimeout(() => {
        setCurrentBuyer(prev => (prev + 1) % recentBuyers.length);
        setIsVisible(true);
      }, 500);
    }, 20000); // Every 20 seconds
    return () => clearInterval(interval);
  }, [isDismissed]);
  // Auto-hide after 6 seconds
  useEffect(() => {
    if (!isVisible || isDismissed) return;
    const hideTimeout = setTimeout(() => {
      setIsVisible(false);
    }, 6000);
    return () => clearTimeout(hideTimeout);
  }, [isVisible, currentBuyer, isDismissed]);
  const buyer = recentBuyers[currentBuyer];
  if (isDismissed) return null;
  return <AnimatePresence data-id="element-145">
      {isVisible && <motion.div initial={{
      opacity: 0,
      x: -100,
      y: 20
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      x: -100
    }} transition={{
      type: 'spring',
      damping: 25,
      stiffness: 300
    }} className="fixed bottom-4 left-4 z-50 max-w-sm" data-id="element-146">
          <div className="bg-white rounded-xl shadow-2xl border border-gray-100 p-4 flex items-start gap-3" data-id="element-147">
            <div className="flex-shrink-0 w-10 h-10 bg-green-100 rounded-full flex items-center justify-center" data-id="element-148">
              <ShoppingBag className="w-5 h-5 text-green-600" data-id="element-149" />
            </div>

            <div className="flex-1 min-w-0" data-id="element-150">
              <p className="text-sm font-semibold text-navy" data-id="element-151">
                {buyer.name} de {buyer.location}
              </p>
              <p className="text-sm text-gray-600" data-id="element-152">
                compró el Kit "Dormí de Nuevo"
              </p>
              <p className="text-xs text-gray-400 mt-1" data-id="element-153">{buyer.time}</p>
            </div>

            <button onClick={() => setIsDismissed(true)} className="flex-shrink-0 p-1 hover:bg-gray-100 rounded-full transition-colors" aria-label="Cerrar notificación" data-id="element-154">
              <X className="w-4 h-4 text-gray-400" data-id="element-155" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}